class KabelclipsLogoSelection extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('select');
    this.form = this.closest('form');
    if (!this.select || !this.form) return;

    const existing = this.peers().find((element) => element !== this && element.ready);
    const value = existing?.select?.value ?? this.select.value;
    this.ready = true;
    this.onChange = () => this.synchronize(this.select.value);
    this.onSubmit = (event) => {
      if (this.select.value !== '') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.querySelector('[data-request-note] a')?.focus();
    };
    this.select.addEventListener('change', this.onChange);
    this.form.addEventListener('submit', this.onSubmit, true);
    this.synchronize(value);
    this.querySelector('[data-request-option]').disabled = false;
  }

  disconnectedCallback() {
    this.select?.removeEventListener('change', this.onChange);
    this.form?.removeEventListener('submit', this.onSubmit, true);
  }

  peers() {
    return Array.from(document.querySelectorAll('kabelclips-logo-selection'))
      .filter((element) => element.dataset.productId === this.dataset.productId);
  }

  synchronize(value) {
    const requestOnly = value === '';
    for (const element of this.peers()) {
      if (!element.ready) continue;
      element.select.value = value;
      element.form.dataset.kabelclipsRequest = String(requestOnly);
      element.querySelector('[data-request-note]').hidden = !requestOnly;
      for (const input of element.form.querySelectorAll('input[name="id"]')) {
        if (!input.hasAttribute('data-kabelclips-original-disabled')) {
          input.dataset.kabelclipsOriginalDisabled = String(input.disabled);
        }
        input.disabled = requestOnly || input.dataset.kabelclipsOriginalDisabled === 'true';
      }
    }

    for (const sticky of document.querySelectorAll('sticky-add-to-cart')) {
      if (sticky.dataset.productId !== this.dataset.productId) continue;
      sticky.dataset.kabelclipsRequest = String(requestOnly);
    }
  }
}

if (!customElements.get('kabelclips-logo-selection')) {
  customElements.define('kabelclips-logo-selection', KabelclipsLogoSelection);
}
